export function formatUsd(value: number) {
  return value.toFixed(2)
}
